import Notification from './Notification';
export default Notification;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-notification/src/index.js